






























import { Vue, Prop, Component } from 'vue-property-decorator'

export interface NavSection {
    title: string
    items: NavItem[]
}

export interface NavItem {
    icon: string
    title: string
    path: string
}

@Component({ name: 'settings-navigation' })
export default class SettingsNavigation extends Vue {
    @Prop({ type: Array, default: () => [] })
    sections!: NavSection[]
}
